/**
 * Legacy module — preserved empty so `acme.common.service.posConfigOptions`
 * keeps resolving. Real impl (internal sub-service of PosConfigService, not
 * downgrade-registered):
 *   apps/b2b-frontend/app/core/pos-config/options/pos-config-options.service.ts
 * Wave 3 item #17.
 */
angular.module('acme.common.service.posConfigOptions', []);
